import {IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate,IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { OneToMany } from 'typeorm';

export class LocationsDto {
  @ApiProperty()
  @IsNotEmpty({message:"id should not be empty"})
  @IsOptional()
  id:number;

  @ApiProperty()
  @IsNotEmpty({message:"location Name should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  locationName: string;


  @ApiProperty()
  @IsNotEmpty({message:"address should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  address: string;

  @ApiProperty()
  @IsNotEmpty({message:"address should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  unitNo: string;

  @ApiProperty()
  @IsNotEmpty({message:"address should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  divisionId: number;

  @ApiProperty()
  @IsNotEmpty({message:"Plant should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  plantId: number;

  @ApiProperty()
  @IsNotEmpty({message:"address should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  state: string;

  @ApiProperty()
  @IsNotEmpty({message:"Gps should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  gpsLocation: string;

  @ApiProperty()
  isActive: boolean;

  createdAt : Date;

  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Created User allows maximum 40 characters" })
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "created user should be only numbers" })
  createdUser : string;

  updatedAt : Date;

  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Updated User allows maximum 40 characters"})
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "updated user should be only numbers" })
  updatedUser : string;

  @ApiProperty()
  versionFlag : number;

 
}

